var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 608,
    viewBox: "0 0 328 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4176_63014)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 608,
    rx: 16,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4176_63014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 206.981V0.765625H71.5189L0 206.981Z",
    fill: "url(#paint0_linear_4176_63014)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4176_63014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 398.179V0.765625H137.829L0 398.179Z",
    fill: "url(#paint1_linear_4176_63014)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f_4176_63014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.359 404.899C359.578 404.899 361.653 291.262 365.553 192.824C381.263 -203.731 366.662 164.821 355.647 575.552C365.962 575.579 374.568 575.489 379.767 575.219C384.683 166.14 384.408 -199.851 384.705 195.457C384.835 369.026 385.117 572.25 385.117 574.438C385.117 574.788 383.174 575.043 379.767 575.219C375.748 909.597 368.261 1272.76 354.159 1272.49C340.089 1272.22 346.68 909.908 355.647 575.552C346.564 575.529 336.157 575.416 325.586 575.258C292.861 574.768 276.498 574.524 267.071 562.458C257.643 550.393 261.082 535.661 267.96 506.198C281.06 450.078 303.458 404.899 333.359 404.899Z",
    fill: "url(#paint2_linear_4176_63014)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4176_63014",
    x: -184,
    y: -183.234,
    width: 439.519,
    height: 574.216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92,
    result: "effect1_foregroundBlur_4176_63014"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4176_63014",
    x: -800,
    y: -799.234,
    width: 1737.83,
    height: 1997.41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 400,
    result: "effect1_foregroundBlur_4176_63014"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4176_63014",
    x: 21.2959,
    y: -217.024,
    width: 603.821,
    height: 1729.51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_4176_63014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4176_63014",
    x1: 60.8947,
    y1: 28.4105,
    x2: -31.8742,
    y2: 63.1444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6661FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4176_63014",
    x1: 117.354,
    y1: 54.042,
    x2: -61.427,
    y2: 120.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B61FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4176_63014",
    x1: 367.952,
    y1: 497.959,
    x2: 201.144,
    y2: 460.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000BE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9061FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4176_63014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 608,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotBackground);
export default __webpack_public_path__ + "static/media/chatbot-background.0fa04711ff67d27c7f0691b0e9d3c5f9.svg";
export { ForwardRef as ReactComponent };